import { apm } from "@elastic/apm-rum";
import { IconButton, Tooltip } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { monitor } from "shared/common/services/apm-logging";
import { sidebarStore } from "shared/common/stores/sidebarStore";
import {
  Straighten,
  StraightenActive,
} from "shared/common/utils/icons/measurementIcons";
import measurementTools, {
  MeasurementType,
} from "shared/common/utils/measurements/measurementTools";
import PopoverBox from "shared/common/utils/popover/PopoverBox";
import MeasurementContent from "./MeasurementContent";
import SmallToolContent from "./SmallToolContent";

export default function Measurements() {
  const { t } = useTranslation();
  const tools = measurementTools();

  const measurementPopover = sidebarStore((state) => state.measurementPopover);
  const changeMeasurementPopover = sidebarStore(
    (state) => state.changeMeasurementPopover
  );
  const lastMeasurementActiveTool = sidebarStore(
    (state) => state.lastMeasurementActiveTool
  );
  const changeMeasurementActiveTool = sidebarStore(
    (state) => state.changeMeasurementActiveTool
  );
  const showSmallToolContent = sidebarStore(
    (state) => state.showSmallToolContent
  );
  const closeAllToolPopover = sidebarStore(
    (state) => state.closeAllToolPopover
  );

  //change table button and popover
  const handleClickMeasurement = () => {
    closeAllToolPopover();
    changeMeasurementPopover(!measurementPopover);
  };

  //change measure icon if active measure tool is different from cursor
  const icon = () => {
    if (lastMeasurementActiveTool.length > 0) {
      if (lastMeasurementActiveTool.length > 1) {
        let i: MeasurementType | undefined;
        lastMeasurementActiveTool.forEach((item: MeasurementType) => {
          if (item.id !== "cursor") {
            i = tools.find((items) => items.id === item.id);
          }
        });
        if (i) {
          if (measurementPopover) {
            return i.filledIcon;
          } else {
            return i.icon;
          }
        }
      } else {
        if (lastMeasurementActiveTool[0].id !== "cursor") {
          const i: MeasurementType | undefined = tools.find(
            (item) => item.id === lastMeasurementActiveTool[0].id
          );
          if (i) {
            if (measurementPopover) {
              return i.filledIcon;
            } else {
              return i.icon;
            }
          }
        } else {
          if (measurementPopover) {
            return <StraightenActive />;
          } else {
            return <Straighten />;
          }
        }
      }
    } else {
      if (measurementPopover) {
        return <StraightenActive />;
      } else {
        return <Straighten />;
      }
    }
  };

  //when measurement is closed and small tool content closed, remove active measure tool
  useEffect(() => {
    if (!measurementPopover && !showSmallToolContent) {
      changeMeasurementActiveTool([]);
    }
  }, [measurementPopover, showSmallToolContent]);

  return (
    <>
      <Tooltip
        title={t("tooltip.measurement")}
        placement="right"
        enterDelay={400}
        classes={{
          tooltip: "infra3d-buttonDescription",
        }}
      >
        <IconButton
          className="onboarding-measurement"
          id="infra3d-measurementButton"
          sx={{
            width: "40px",
            height: "40px",
            overflow: "hidden",
            mx: "auto",
            color: "white",
            "@media (hover: hover)": {
              ":hover": { color: "secondary.main" },
            },
          }}
          classes={{
            root: measurementPopover
              ? "infra3d-iconButtonRippleActive"
              : "infra3d-iconButtonRipple",
          }}
          onClick={() =>
            monitor(
              apm,
              "change-status-measure | Toolbar",
              handleClickMeasurement
            )
          }
          disableRipple={true}
        >
          {icon()}
        </IconButton>
      </Tooltip>
      <PopoverBox visible={measurementPopover}>
        <MeasurementContent />
      </PopoverBox>
      {showSmallToolContent && <SmallToolContent />}
    </>
  );
}
